import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const basicOptions = [
  { label: 'Preço fixo', value: 'fixed' },
]

export const fuelOptions = [
  { label: 'Preço dinâmico', value: 'dynamic' },
  { label: 'ANP - Mínima', value: 'anp_minimum' },
  { label: 'ANP - Média', value: 'anp_average' },
  { label: 'ANP - Máxima', value: 'anp_maximum' },
]

export const privateFuelOptions = [
  ...fuelOptions,
  { 
    label: 'Média ANP (mesmo estado) / Máxima ANP (UF diferente)', 
    value: 'anp_average_but_anp_maximum_when_out_of_client_matrix_state', 
    tooltip: 'Aplica média ANP quando o posto está no mesmo estado da matriz do cliente. Para postos em outros estados, aplica ANP máxima da UF.' 
  },
]

export const options = [
  ...basicOptions,
  ...fuelOptions,
]

export const strategy = optionsToStrategy(options)
export const privateFuelStrategy = optionsToStrategy(privateFuelOptions)

export const getPriceRuleOptions = ({isFuel, isPrivateFuel}: {isFuel?: boolean, isPrivateFuel?: boolean}) => {
  if (isFuel) return options

  if (isPrivateFuel) return privateFuelOptions
  
  return basicOptions
}
